import gsap from 'gsap';
import Timeout from 'await-timeout';
import { throttle } from 'throttle-debounce';

import pageContent from '../components/page-content';

const els = {
    $header: () => $('[data-page-header]'),
    $inner: () => els.$header().find('[data-page-header-inner]'),
    $heading: () => els.$header().find('[data-page-header-heading]'),
};

const disableTransitions = () => {
    gsap.set(
        els.$inner().add(els.$heading()),
        { transition: 'none' }
    );
};

const enableTransitions = () => {
    gsap.set(
        els.$inner().add(els.$heading()),
        { clearProps: 'all' }
    );
};

const show = () => {
    gsap.set(
        els.$header(),
        { visibility: 'visible' }
    );
};

const isSticking = () => (
    els.$header().attr('data-is-sticking') == '1'
);

const minHeight = () => (
    parseInt(els.$inner().attr('data-min-height'), 10)
);

const setSticking = () => {
    const $header = els.$header();

    const isSticking = $header.offset().top === 0;
    const hasScrolled = pageContent.els.$content().scrollTop() > 0;

    $header.attr(
        'data-is-sticking',
        isSticking && hasScrolled ? '1' : '0'
    );
};

const initialize = async () => {
    disableTransitions();
    setSticking();
    await Timeout.set(0);
    enableTransitions();
    show();

    $(window).on(
        'resize:horizontally',
        throttle(50, setSticking)
    );

    pageContent.els.$content().on(
        'scroll',
        throttle(50, setSticking)
    );
};

export default {
    els,
    initialize,
    isSticking,
    minHeight,
};

